// const BASE_URL = "http://localhost:3001";
const BASE_URL = "https://sw-project-backend.onrender.com";

export default BASE_URL;
